// extracted by mini-css-extract-plugin
var _1 = "header-content--m6ZHT";
var _2 = "header-sort-icon--j5pe3";
var _3 = "header-text--r69oA";
var _4 = "inline--g2u75";
var _5 = "opacity30--ydacn";
var _6 = "resize-handler--LNeHj";
export { _1 as "header-content", _2 as "header-sort-icon", _3 as "header-text", _4 as "inline", _5 as "opacity30", _6 as "resize-handler" }
